/**
 * Safely get a value from localStorage with JSON parsing.
 * Handles Safari private browsing and other restricted environments.
 *
 * @param {string} key - The localStorage key
 * @param {*} defaultValue - Value to return if key doesn't exist or on error
 * @returns {*} The parsed value or defaultValue
 */
export function storageGet(key, defaultValue = null) {
  try {
    const value = localStorage.getItem(key)
    if (value === null) return defaultValue
    return JSON.parse(value)
  } catch (e) {
    console.error(`Failed to read from localStorage [${key}]:`, e)
    return defaultValue
  }
}

/**
 * Safely set a value in localStorage with JSON serialization.
 * Handles Safari private browsing and other restricted environments.
 *
 * @param {string} key - The localStorage key
 * @param {*} value - The value to store (will be JSON stringified)
 * @returns {boolean} True if successful, false on error
 */
export function storageSet(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value))
    return true
  } catch (e) {
    console.error(`Failed to write to localStorage [${key}]:`, e)
    return false
  }
}

/**
 * Safely remove a key from localStorage.
 * Handles Safari private browsing and other restricted environments.
 *
 * @param {string} key - The localStorage key to remove
 * @returns {boolean} True if successful, false on error
 */
export function storageRemove(key) {
  try {
    localStorage.removeItem(key)
    return true
  } catch (e) {
    console.error(`Failed to remove from localStorage [${key}]:`, e)
    return false
  }
}
